
import "./components/common/LazyImg";

/**
 * This is our clientside javascript entry point
 */

// The Ceres bundle provides Vue, we do not need to bundle it ourself
const Vue = window.Vue;
var initShopbuilderScripts = false;

$(document).on("shopbuilder.before.viewUpdate shopbuilder.after.viewUpdate", function(event, eventData, widgetElement)
{
    if(!initShopbuilderScripts){
        initShopbuilderScripts = true;
    }
    
});
